import { format, isValid, parseISO } from 'date-fns';

const formatDate = (date, dateFormat = 'dd/MM/yyyy HH:mm:ss') => {
  if (!date) return '-';

  let parsedDate;
  if (typeof date === 'string') {
    parsedDate = parseISO(date);

    if (!isValid(parsedDate)) {
      parsedDate = new Date(date);
    }
  } else {
    parsedDate = new Date(date);
  }

  if (!isValid(parsedDate)) return '-';

  return format(parsedDate, dateFormat);
};

export default formatDate;
